/* global gtag_report_conversion */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FiPhone } from "react-icons/fi";
import { ReactComponent as Logo } from "../images/logo.svg";
import "../styles/common.css";
import "../styles/navbar.css";

const PHONE_TEL = "tel:+36206282000";

const MainNavbar = () => {
  const [expanded, setExpanded] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/";

  const navItems = [
    { label: "Főoldal", href: "#hero" },
    { label: "Rólunk", href: "#aboutus" },
    { label: "Szolgáltatások", href: "#services" },
    { label: "Kiszállási területek", href: "#locations" },
    { label: "Kapcsolat", href: "#contact" },
  ];

  // Close menu on Escape
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setExpanded(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setExpanded(false);
  }, [location.pathname]);

  // If we navigated to "/" with a scroll target in state, scroll to it
  useEffect(() => {
    if (!isHomePage) return;
    const target = location.state?.scrollTo;
    if (!target) return;
    // let the route render before scrolling
    setTimeout(() => {
      const el = document.querySelector(target);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        // update hash (optional)
        window.history.replaceState(null, "", target);
      }
    }, 0);
  }, [isHomePage, location.state]);

  const onNavClick = (hash) => (e) => {
    e.preventDefault();
    if (!isHomePage) {
      // Go home and then scroll (handled by the effect above)
      navigate("/", { state: { scrollTo: hash } });
    } else {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        window.history.replaceState(null, "", hash);
      }
    }
    setExpanded(false);
  };

  const toggleMenu = () => setExpanded((prev) => !prev);

  return (
    <nav className="navbar navbar-expand-lg sticky-top custom-navbar">
      <div className="container d-flex align-items-center justify-content-between justify-content-lg-start nav-container">
        {/* Brand */}
        <a href="/" className="navbar-brand d-flex align-items-center">
          <Logo className="me-lg-3 nav-logo" />
          <span className="d-none d-lg-inline">bikazaspest.hu</span>
        </a>

        {/* Mobile-only call button (use <a> for tel:) */}
        <a
          href={PHONE_TEL}
          className="nav-call-btn d-lg-none mx-auto"
          onClick={(e) => {
            e.preventDefault();
            gtag_report_conversion("tel:+36206282000");
          }}
        >
          <FiPhone className="me-2" /> +36 20 628 2000
        </a>

        {/* Hamburger */}
        <button
          className={`navbar-toggler custom-toggler p-4 ${
            expanded ? "open" : ""
          }`}
          type="button"
          onClick={toggleMenu}
          aria-controls="main-navbar"
          aria-expanded={expanded}
          aria-label="Toggle navigation"
        >
          <span className="toggler-bar"></span>
        </button>

        {/* Collapse */}
        <div
          id="main-navbar"
          className={`collapse navbar-collapse justify-content-lg-end ${
            expanded ? "show" : ""
          }`}
        >
          <ul className="navbar-nav flex-lg-row flex-column align-items-lg-center align-items-center gap-3 gap-lg-0">
            {navItems.map((item, idx) => (
              <li className="nav-item" key={idx}>
                {/* Use <a> since these are in-page anchors */}
                <a
                  href={item.href}
                  className="nav-link"
                  onClick={onNavClick(item.href)}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default MainNavbar;
